// extracted by mini-css-extract-plugin
module.exports = {"part5":"part5_part5__3D18Q","inner":"part5_inner__3aPdC","left":"part5_left__PTOZI","right":"part5_right__aGX1N"};